exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss"), undefined);

// module
exports.push([module.id, ".Social__verifyButtonSurround___3jGfJ {\n    display: flex;\n    justify-content: flex-end;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + "",
	"secondaryColour": "" + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["secondaryColour"] + "",
	"verifyButtonSurround": "Social__verifyButtonSurround___3jGfJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/User/Social.icss
// module id = 1594
// module chunks = 0